export const GET_ALL_INACTIVITY_REPORT = 'GET_ALL_INACTIVITY_REPORT'
export const SET_LOADING_INACTIVITY_REPORT = 'SET_LOADING_INACTIVITY_REPORT'
